import { HeaderContext as LibHeaderContext } from '@tanstack/react-table';
import { getTableMetaHelper } from '@round/ui-kit';
import {
    CellContext,
    ExplorePlatform,
    Meta as BaseMeta,
} from 'Modules/Plans/CreatorSearch/components/CreatorExploreTable/helpers';

export type HeaderContext = LibHeaderContext<CellContext['row']['original'], unknown>;

export type Meta = Pick<
    BaseMeta,
    'isLoading' | 'hasError' | 'getCreatorImages' | 'getAreCreatorImagesLoading' | 'getRowSelectedPlatform'
> & {
    /** The campaign's platform. Every row is a member on it, so the platform column is fixed. */
    platform: ExplorePlatform | undefined;
    /**
     * TODO(ROU-1264): creatorbase-ui's VirtualizedTable doesn't forward react-table's
     * row-selection state yet. Once it does, drop this for that API, keyed on the
     * account id rather than the row index.
     */
    selectedAccountIds: Set<number>;
    isAlreadyInCampaign: (accountId: number) => boolean;
    /** The campaign's posts decide the already-added indicator, so it shows a skeleton until they land. */
    areCampaignPostsLoading: boolean;
};

export const getTableMeta = getTableMetaHelper<Meta>();
